import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import InputField from '../../../../components/InputField';
import axiosInstance from '../../../../services/AxiosInstance';
import { userContext } from '../../../../contextProvider/Authentication';
import swal from 'sweetalert';

function Achievements({ stud_id }) {

    const [input, setInput] = useState();
    const { user } = useContext(userContext);

    useEffect(() => {
        getAchievements();
        // eslint-disable-next-line
    }, []);

    const getAchievements = () => {
        var url = stud_id ? `can-achievements/?candidate=${stud_id}` : "can-achievements/";
        axiosInstance(
            url, {
            method: "GET",
            data: {}
        }).then(res => {
            setInput(res?.data?.results?.[0])
        }).catch(err => {
            console.log('err: ', err);
        })
    }

    const handleSubmit = () => {
        input["candidate"] = stud_id ?? user?.id;

        var url = input?.id ? `can-achievements/${input?.id}/` : "can-achievements/";
        var method = input?.id ? "PUT" : "POST";
        axiosInstance(
            url, {
            method: method,
            data: input
        }).then(res => {
            if (res?.status === 200 || res?.status === 201) {
                getAchievements();
                swal("", "Succesfully saved", "success", { button: "Ok!", });
            }
        }).catch(err => {
            swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
        })
    }

    return (
        <div id="profile_summary_bx" className="job-bx bg-white m-b30">
            <div>
                <h5 className="mb-0">Achievements</h5>
            </div>
            <p>Sports, patents, publications, books, awards, etc.</p>
            <div>
                <InputField
                    label="Achievements"
                    name="Achievements"
                    textType="textarea"
                    value={input?.Achievements}
                    onChange={(e) => setInput({ ...input, [e.target.name]: e.target.value })}
                    placeholder="Enter Achievements"
                />
            </div>
            <button
                type="button"
                className="site-button mt-2"
                onClick={() => handleSubmit()}
                disabled={input?.Achievements?.length > 0 ? false : true}
                style={{ backgroundColor: input?.Achievements?.length > 0 ? "#1d46f5" : "#8b99d5", cursor: input?.Achievements?.length > 0 ? "pointer" : "not-allowed" }}
            >
                Save
            </button>
        </div>
    );
}

export default Achievements;